import { render, staticRenderFns } from "./WechatBindDialog.vue?vue&type=template&id=66e62080&scoped=true"
import script from "./WechatBindDialog.vue?vue&type=script&lang=js"
export * from "./WechatBindDialog.vue?vue&type=script&lang=js"
import style0 from "./WechatBindDialog.vue?vue&type=style&index=0&id=66e62080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e62080",
  null
  
)

export default component.exports